module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAP9JREFUSA1jYBgFBEKAEVn+////IkC+LrIYGezLjIyMb2D64BZADX8IlOCCSZJJfwPqk4dZwkSmIURrg/sApIMWQUS0S8hVSHMfwC0YjWSkOELJB0jitGHC4wBkPBHJ9AEwA92HOQWo3gHI5gWKbYaJ4aRBhgPxVyDGB/4BJe1ghgDZn6CKNwJpSZg4Mk1pTuaFGuYHpK8CLYlHNhzEpjSI/qMbCORvA+IoYLB9xCJHmhA0eLBRWTCTWGAMEA1USai4RolkZL1IbJAPViHxIUyQ4UBMaiQju/4dkIMRB5RGMqjsB4FNQKwNDPeFYB4SQWkkOwDN4gQavB3JzGHGBABea9vsSUnQogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq/icon_mylist.png
// module id = cKiY
// module chunks = 1